window.FcmServerKey = process.env.MIX_FCM_SERVER_KEY;
window.LaravelEchoPort = process.env.MIX_LARAVEL_ECHO_PORT;
